import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from './click-outside.directive';
import { CountUpDirective } from './count-up.directive';
import { HighlightDirective } from './highlight.directive';
import { DeviceSerialValidatorDirective } from './device-serial-validator.directive';
import { DatePickerFormatDirective } from './datapicker-format.directive';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
  imports: [
    CommonModule,
    MatNativeDateModule,
    MatDatepickerModule
  ],
  declarations: [
    ClickOutsideDirective,
    CountUpDirective,
    HighlightDirective,
    DeviceSerialValidatorDirective,
    DatePickerFormatDirective
  ],
  exports: [
    ClickOutsideDirective,
    CountUpDirective,
    HighlightDirective,
    DeviceSerialValidatorDirective,
    DatePickerFormatDirective
  ]
})
export class UtilsModule { }
